import CookiePreferencesButton from "@/app/components/CookieConsent/CookiePreferencesButton";
import { COOKIE_CONSENT_COOKIE_NAME } from "@/app/config/cookie-consent";
import { BRAND_NAMES } from "@/app/utils/utils";
import styles from "@/styles/Cookies.module.scss";

const PRIVACY_PORTAL = "https://privacidadecomercio.aguiabranca.com.br";

export default function CookiesPage() {
	return (
		<article className={styles.page}>
			<h1 className={styles.title}>Política de Cookies</h1>
			<CookiePreferencesButton className={styles.preferences} />
			<p className={styles.updated}>
				{BRAND_NAMES.DEFAULT} Toyota — toyotakyoto.com.br
			</p>

			<section className={styles.section}>
				<p>
					Esta página descreve como a {BRAND_NAMES.LEGAL} (Divisão
					Comércio GAB – CNPJ 00.827.783/0001-81) utiliza cookies e
					tecnologias semelhantes no site toyotakyoto.com.br, em
					conformidade com a Lei Geral de Proteção de Dados (LGPD).
				</p>
				<p>
					No primeiro acesso, o banner{" "}
					<strong>Controle sua privacidade</strong> permite aceitar,
					rejeitar ou personalizar as categorias de cookies. A escolha
					fica gravada no cookie{" "}
					<strong>{COOKIE_CONSENT_COOKIE_NAME}</strong>, tratado como{" "}
					<strong>estritamente necessário</strong> (validade de 60
					dias).
				</p>
			</section>

			<section className={styles.section}>
				<h2>O que são cookies</h2>
				<p>
					Cookies são arquivos pequenos gravados no seu dispositivo
					quando você visita um site. Eles servem para o funcionamento
					básico da página, lembrar preferências, medir audiência e,
					quando autorizado, apoiar marketing.
				</p>
			</section>

			<section className={styles.section}>
				<h2>Categorias</h2>
				<div className={styles.tableWrap}>
					<table>
						<thead>
							<tr>
								<th>Categoria</th>
								<th>Finalidade</th>
								<th>Consentimento</th>
							</tr>
						</thead>
						<tbody>
							<tr>
								<td>Necessários</td>
								<td>
									Operação do site, segurança e registro da
									escolha de cookies (
									{COOKIE_CONSENT_COOKIE_NAME}).
								</td>
								<td>Sempre ativos</td>
							</tr>
							<tr>
								<td>Performance</td>
								<td>
									Medir desempenho e estabilidade das páginas.
								</td>
								<td>Opcional</td>
							</tr>
							<tr>
								<td>Funcional</td>
								<td>
									Lembrar preferências e recursos que melhoram
									a experiência.
								</td>
								<td>Opcional</td>
							</tr>
							<tr>
								<td>Marketing</td>
								<td>
									Anúncios e remarketing, conforme as tags
									autorizadas.
								</td>
								<td>Opcional</td>
							</tr>
							<tr>
								<td>Estatísticas</td>
								<td>
									Medir visitas e uso do site de forma
									agregada.
								</td>
								<td>Opcional</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section className={styles.section}>
				<h2>Como gerenciar sua escolha</h2>
				<p>
					Depois da primeira escolha, use o botão no topo desta página
					ou <strong>Mostrar preferências de cookie</strong> no
					rodapé para reabrir o modal{" "}
					<strong>Quem pode usar seus cookies?</strong>
				</p>
			</section>

			<section className={styles.section}>
				<h2>Privacidade</h2>
				<p>
					Para exercer direitos de titular e consultar a política
					completa de privacidade do Grupo Águia Branca — Divisão
					Comércio, acesse o{" "}
					<a
						href={PRIVACY_PORTAL}
						target="_blank"
						rel="noopener noreferrer"
					>
						Portal de Privacidade
					</a>
					.
				</p>
			</section>
		</article>
	);
}
